import React from "react";

export const Icons = {};

export default (props: any) => <div {...props}>Default Layout</div>;
